// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"palace"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M12 4C13.6569 4 15 5.34315 15 7V8H17V11H20V21H4V11H7V8H9V7C9 5.34315 10.3431 4 12 4Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M9 18C9 16.3431 10.3431 15 12 15V15C13.6569 15 15 16.3431 15 18V21H9V18Z"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M9 18C9 16.3431 10.3431 15 12 15V15C13.6569 15 15 16.3431 15 18V21H9V18Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M15 8V7C15 5.34315 13.6569 4 12 4M15 8H17M15 8H9M9 8V7C9 5.34315 10.3431 4 12 4M9 8H7M17 8V11M17 8H18M17 11H7M17 11H20M7 11V8M7 11H4M7 8H6M4 11V21M4 11H3M4 21H3M4 21H20M20 11V21M20 11H21M20 21H21M12 4V3","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const PalaceIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'palace',
    ref,
    icon: element,
  },
));

PalaceIcon.displayName = 'PalaceIcon';

export default PalaceIcon;
